import { render } from "./NameBudgetUpdate.vue?vue&type=template&id=c2336174"
import script from "./NameBudgetUpdate.vue?vue&type=script&lang=js"
export * from "./NameBudgetUpdate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__